class FocusableHandler {
	private options: { focusable?: string[]; nonFocusable?: string[] } = {};

	init(options: { focusable?: string[]; nonFocusable?: string[] }) {
		this.options = options;
	}

	setFocusable = () => {
		if (this.options.focusable) {
			this.options.focusable.forEach((selector) => {
				const elements = document.querySelectorAll(selector) as NodeListOf<HTMLElement>;
				elements.forEach((el) => this.setFocusability(el, true));
			});
		}

		if (this.options.nonFocusable) {
			this.options.nonFocusable.forEach((selector) => {
				const elements = document.querySelectorAll(selector) as NodeListOf<HTMLElement>;
				elements.forEach((el) => this.setFocusability(el, false));
			});
		}
	};

	// Set an element's tabindex to 0 to make it focusable, or -1 to make it unfocusable.
	setFocusability = (el: HTMLElement, isFocusable: boolean) => {
		if (isFocusable) {
			el.setAttribute('tabindex', '0');
		} else {
			el.setAttribute('tabindex', '-1');
		}
	};
}

export default new FocusableHandler();
